import React, { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";

import styles from "./styles.module.scss";
import Button from "../../common/Button";
import { ModalActions } from "src/redux/Modal/actions";
import ConfirmResetSecretKey from "../ConfirmResetSecretKey";
import { SettingsSelectors } from "src/redux/Settings/selectors";
import { ToasterActions } from "src/redux/Toaster/actions";

const ManageSecretKey = () => {
    const dispatch = useDispatch();
    const selectedPeerCpty = useSelector(
        SettingsSelectors.SelectedPeerCptySetting
    );
    const copySecret = () => {
        navigator.clipboard.writeText(selectedPeerCpty?.secret);
        dispatch(ToasterActions.NewOK("Secret copied to clipboard"));
    };
    return (
        <Fragment>
            <div className={styles.manageSecretKeyWrapper}>
                <div className={styles.subTitle}>
                    <p>
                        You will need to provide this to your Lender using a
                        method that is in line with your internal security
                        policy.
                    </p>
                </div>
                <div>
                    Your Lender traders will need this key to authenticate their
                    devices to enable them to respond to your locates.
                </div>
                <div className={styles.copySecretCodeWrapper}>
                    <div className={styles.secretCodeWrapper}>
                        <h2>{selectedPeerCpty?.secret}</h2>
                    </div>
                </div>
                <div className={styles.resetKeyButtonWrapper}>
                    <Button
                        data-testid={`copy-secret-${selectedPeerCpty?.cptyCode}`}
                        onClick={copySecret}
                        value="Copy"
                        dataTestId="copy-secret-key"
                    />
                    <Button
                        onClick={() =>
                            dispatch(
                                ModalActions.Open(ConfirmResetSecretKey, {
                                    width: 500,
                                    ignoreClickOutside: true,
                                    title: "Are you sure?",
                                })
                            )
                        }
                        color="lightRed"
                        value="Reset"
                        dataTestId="reset-secret-key"
                    />
                </div>
                <div className={styles.ManageSecretKeyFooter}>
                    <p>
                        Tru recommend using a secure method to send this key to
                        your Lender and avoiding Email as this provides limited
                        security.
                    </p>
                </div>
                <div className={styles.ManageSecretKeyCloseButton}>
                    <Button
                        classes={styles.closeButton}
                        onClick={() => dispatch(ModalActions.Close())}
                        color="reversedWhite"
                        value="Close"
                        dataTestId="close-secret-key-modal"
                    />
                </div>
            </div>
        </Fragment>
    );
};

export default ManageSecretKey;
